export const RECEIVED_PRICE_PERCENT = 10

export const MAKE_UNIVERSAL_OPTION = 'Universal'

export const MAKE_SOURCE_TYPE = {
  imported: 'imported',
  system: 'system'
}
